// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__item-text[data-v-68f19eab]{height:40px;text-align:left;font:normal normal normal 24px/32px Segoe UI;letter-spacing:0;color:#707070;opacity:1}", ""]);
// Exports
module.exports = exports;
